import { useMemo } from 'react';
import BrowserStorageAccessor from 'common/utils/BrowserStorageAccessor';
import { STORAGE_TYPES } from 'common/constants/constants';

const isObject = obj => {
  try {
    JSON.parse(obj);
    return true;
  } catch (E) {
    return false;
  }
};

const useRestoreFromStorage = ({
  key,
  storageType = STORAGE_TYPES.LOCAL,
  defaultValue = {}
}) => {
  const storageAccessor = BrowserStorageAccessor()[storageType];

  const value = useMemo(() => {
    const storedValue = storageAccessor.get(key);
    if (!storedValue) return defaultValue;
    return isObject(storedValue) ? JSON.parse(storedValue) : storedValue;
  }, [key]);

  return value;
};

export default useRestoreFromStorage;
